// <collection-filters> — sort select and the in-stock switch submit at once (Shopify storefront filtering:
// `sort_by` and `filter.v.availability`). There is no filter drawer.
class CollectionFilters extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-cl-form]');
    this.sw = this.querySelector('[data-stock-switch]');
    this.stockKey = 'filter.v.availability';
    this.sw.setAttribute('aria-checked', String(new URLSearchParams(location.search).get(this.stockKey) === '1'));
    this.querySelector('[data-sort]')?.addEventListener('change', () => this.go());
    this.sw.addEventListener('click', () => this.toggleStock());
    this.form.addEventListener('submit', (e) => { e.preventDefault(); this.go(); });
  }
  params() {
    const p = new URLSearchParams();
    new FormData(this.form).forEach((v, k) => { if (v !== '' && v != null) p.append(k, v); });
    if (new URLSearchParams(location.search).get(this.stockKey) === '1') p.set(this.stockKey, '1');
    return p;
  }
  toggleStock() {
    const p = new URLSearchParams(location.search);
    if (p.get(this.stockKey) === '1') p.delete(this.stockKey); else p.set(this.stockKey, '1');
    p.delete('page'); location.search = p.toString();
  }
  go() { location.search = this.params().toString(); }
}
if (!customElements.get('collection-filters')) customElements.define('collection-filters', CollectionFilters);
